/**
 * Feature flags convention: go/frontend-feature-flags
 */

import { useBooleanFeatureFlag } from '@confluence/session-data';

// LD FF: https://app.launchdarkly.com/confluence/production/features/confluence.frontend.reactions-in-feed/targeting
export const REACTIONS_IN_FEED_FEATURE_FLAG = 'confluence.frontend.reactions-in-feed';

export const useIsReactionsInFeedEnabled = () => {
	return useBooleanFeatureFlag(REACTIONS_IN_FEED_FEATURE_FLAG);
};
